import React from 'react';
import styles from './webDealImagePlaceholder.module.scss';

export default function WebDealImagePlaceholder() {
    return (
        <div className={styles.container} data-testid={'web-deal-image-placeholder'}>
            <span className={styles.text}>Web</span>
            <span className={styles.text}>Deal</span>
        </div>
    );
}
